import React from 'react';
import PropTypes from 'prop-types';
import styles from './Modal.m.sass';
import cx from 'classnames';

export default class Modal extends React.PureComponent {
  close = () => {
    const {onClose} = this.props;

    if (onClose) {
      onClose();
    }
  };

  onOverlayClick = evt => {
    if (!this.refs.modalBody.contains(evt.target)) {
      this.close();
    }
  };

  render() {
    const {cart, className, children} = this.props;

    return (
      <div
        className={cx(
          styles.overlay,
          className,
          {[styles.modal__cart]: cart},
        )}
        onClick={this.onOverlayClick}
      >
        <div className={styles.modal} ref="modalBody">
          <div className={styles.modal_wrapper} ref="modalBody">
            <button className={styles.modal_close} onClick={this.close}>
              <span className={styles.modal_closeIcon}/>
            </button>
            <div className={styles.modal_content}>
              {children}
            </div>
          </div>
        </div>
      </div>
    );
  }
}

Modal.propTypes = {
  className: PropTypes.string,
  type: PropTypes.string,
  children: PropTypes.node,
  onClose: PropTypes.func
};



// WEBPACK FOOTER //
// ./components/modals/Modal.js